import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_MATERIALS,
  PATH_MATERIALS_NEW,
} from '../../app/constants/paths.constant';
import { FormVariant } from '../../forms';
import { MaterialForm } from '../../forms/Material';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewMaterialPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Materials);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'un Matériel")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_MATERIALS,
            label: 'matériels',
            key: 'materials',
          },
          {
            to: PATH_MATERIALS_NEW,
            label: 'nouveau',
            key: 'newMaterial',
          },
        ]}
      />
      <PageTitle title="Création d'un Matériel" />
      <MaterialForm
        formVariant={FormVariant.Creation}
        showCancelButton={false}
      />
    </>
  );
};
